<script setup>
import { ref } from 'vue'
import { useField } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import Services from '../services'

const props = defineProps(['field', 'modelValue'])
const { t, locale } = useI18n()
const focusDate = ref(model.value || new Date())
const modelCalendar = ref(model.value ? new Date(model.value) : null)

const { value: model } = useField(
  () => props.field.clean_name,
  { required: props.field.required },
  {
    syncVModel: true,
  }
)

const setModel = (value) => {
  model.value = Services.formatter.dateToString(value)
}

const formatDate = (date, options) => date.toLocaleString(locale.value, options)

const focusCalendar = (direction) => {
  const date = new Date(focusDate.value)
  date.setMonth(focusDate.value.getMonth() + direction)
  focusDate.value = date
}
</script>

<template>
  <div class="columns is-gapless mb-0">
    <div class="column is-6">
      <b-datepicker
        ref="calendar"
        v-model="modelCalendar"
        @update:modelValue="setModel"
        v-bind="{
          'focused-date': focusDate,
          // 'nearby-selectable-month-days': false,
          // range: true,
          'mobile-native': false,
          locale,
          'first-day-of-week': 1,
          // ...calendarOptions,
        }"
      >
        <template #trigger>
          <button
            type="button"
            class="button is-large is-size-6 is-fullwidth"
            :class="{ 'has-text-grey-dark': !modelCalendar }"
          >
            <span
              v-text="
                modelCalendar
                  ? formatDate(modelCalendar, {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : field.placeholder || t('apply.select')
              "
            />
            <b-icon icon="calendar-blank" class="is-size-4 ml-2" />
          </button>
        </template>
        <template #header>
          <div class="columns is-vcentered is-mobile is-variable is-1 is-nav">
            <div class="column is-narrow mr-auto">
              <button
                type="button"
                class="button is-white is-square"
                @click="focusCalendar(-1)"
              >
                <b-icon icon="caret-left-bold" />
              </button>
            </div>

            <div class="column has-text-centered">
              {{
                formatDate(focusDate, {
                  year: 'numeric',
                  month: 'long',
                })
              }}
            </div>
            <div class="column is-narrow ml-auto">
              <button
                type="button"
                class="button is-white is-square"
                @click="focusCalendar(+1)"
              >
                <b-icon icon="caret-right-bold" />
              </button>
            </div>
          </div>
        </template>
      </b-datepicker>

      <input type="hidden" :name="field.clean_name" :value="model" />
    </div>
  </div>
</template>
